import { render, staticRenderFns } from "./FormMicroCredential.vue?vue&type=template&id=2da99778&"
import script from "./FormMicroCredential.vue?vue&type=script&lang=js&"
export * from "./FormMicroCredential.vue?vue&type=script&lang=js&"
import style0 from "./FormMicroCredential.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports